import { HttpGetTruckPalletList, HttpTruckPalletChangeStatus, HttpTruckPalletImport } from '@/service/bespeak';
import TableList from "@components/templates/tablelist";

export default {
    mixins: [TableList],
    components: {
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
                align: "left"
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetTruckPalletList,
        interceptRequest(data) {
            data.isManage = true;
            data.search.EQ_active = 1;
            return data
        },
        choosePallet(aaa){
            this.$emit('on-success', aaa)
        },
    },
    computed: {
        SearchsData() {
            return [
                {
                    label: "规则名称",
                    key: 'EQ_palletName',
                    tag: 'Input',
                    show: true,
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 90,
                    align: 'center',
                    render: (h, {row})=>{
                        return <div>
                            <Button onClick={this.choosePallet.bind(this, row)} type="primary">选择</Button>
                        </div>
                    }
                },
                {
                    title: "规格名称",
                    key: 'palletName',
                    render:(h,{row})=>{
                        return <div>{row.palletName || '--'}</div>
                    }
                },
                {
                    title: "长（inch）",
                    key: 'length',
                    render:(h,{row})=>{
                        return <div>{row.length || '--'}</div>
                    }
                },
                {
                    title: "宽（inch）",
                    key: 'width',
                    render:(h,{row})=>{
                        return <div>{row.width || '--'}</div>
                    }
                },
                {
                    title: "高（inch）",
                    key: 'height',
                    render:(h,{row})=>{
                        return <div>{row.height || '--'}</div>
                    }
                },
            ];
        },
    },
}
